import { createContext } from 'react';
import { defaultButtonGroupContext } from '@gs-ux-uitoolkit-common/button';

export const ButtonGroupContext = createContext({
    ...defaultButtonGroupContext,
});
